import React, { memo, useState, useEffect } from "react";
import { Modal, Spin } from "antd";
import api from "../../../services/api";
import { notifyError } from "../../../utils/notifications";
import * as S from "../style";

function ModalPaymentInfo({ visible, onClose, paymentData }) {
  const [storeDetails, setStoreDetails] = useState(null);
  const [loading, setLoading] = useState(true);

useEffect(() => {
    let isMounted = true;
    if (!visible) return;

    if (!paymentData?.redeOrigem) {
      setStoreDetails({
        nomeFantasia: "Loja não identificada",
        razaoSocial: "Loja não identificada",
        cnpj: "Não informado",
      });
      setLoading(false);
      return;
    }

    const fetchStoreInfo = async () => {
      setLoading(true);
      try {
        const response = await api.get("get_store_cnpj", {
          redeOrigem: paymentData.redeOrigem,
        });

        if (isMounted) {
          const storeInfo = response.data?.storeInformation;
          setStoreDetails({
            nomeFantasia: storeInfo?.nomeFantasia || "Nome Fantasia não disponível",
            razaoSocial: storeInfo?.razaoSocial || "Razão social não disponível",
            cnpj: storeInfo?.cnpj || paymentData.redeOrigem,
          });
        }
      } catch (error) {
        console.error("Erro ao buscar informações da loja:", error);
        if (isMounted) {
          notifyError("Não foi possível carregar os detalhes da loja.");
          setStoreDetails({
            nomeFantasia: "Informação indisponível",
            razaoSocial: "Informação indisponível",
            cnpj: paymentData.redeOrigem,
          });
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchStoreInfo();

    return () => {
      isMounted = false;
    };
  }, [visible, paymentData]);
  

  return (
    <Modal
      title="Informações da Loja"
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <S.FormRow>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: "20px", width: "100%" }}>
            <Spin tip="Buscando informações da loja..." />
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%" }}>
            <div>
              <strong>Nome Fantasia:</strong> {storeDetails?.nomeFantasia}
            </div>
            <div>
              <strong>Razão Social:</strong> {storeDetails?.razaoSocial}
            </div>
            <div>
              <strong>CNPJ:</strong> {storeDetails?.cnpj}
            </div>
          </div>
        )}
      </S.FormRow>
    </Modal>
  );
}

export default memo(ModalPaymentInfo);